import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoinPurchaseComponent } from './coin-purchase/coin-purchase.component';
import { BonusPurchaseComponent } from './bonus-purchase/bonus-purchase.component';
import { BonusInfoComponent } from './bonus-info/bonus-info.component';
import { BonusCollectionComponent } from './bonus-collection/bonus-collection.component';
import { BonusDayCheckerComponent } from './bonus-day-checker/bonus-day-checker.component';
import { PurchaseSucessComponent } from '../purchase-sucess/purchase-sucess.component';
import { BuyButtonComponent } from '../buttons/buy-button/buy-button.component';
import { BoydPurchaseInfoComponent } from './boyd-purchase-info/boyd-purchase-info.component'
import { CollectButtonComponent } from '../buttons/collect-button/collect-button.component';
import { DayProgressViewComponent } from './day-progress-view/day-progress-view.component'


@NgModule({
  declarations: [
    BonusCollectionComponent,
    BonusDayCheckerComponent,
    BonusPurchaseComponent,
    BonusInfoComponent,
    CoinPurchaseComponent,
    PurchaseSucessComponent,
    BuyButtonComponent,
    BoydPurchaseInfoComponent,
    CollectButtonComponent,
    DayProgressViewComponent
  ],
  exports: [
    BonusCollectionComponent,
    BonusDayCheckerComponent,
    BonusPurchaseComponent,
    BonusInfoComponent,
    CoinPurchaseComponent,
    PurchaseSucessComponent,
    BuyButtonComponent,
    BoydPurchaseInfoComponent,
    CollectButtonComponent,
    DayProgressViewComponent
  ],
  imports: [
    CommonModule,
  ]
})
export class ShopModule { }
